<!--
    Summary:
        首页
    ChangeLog:
        Labbor on 2020/10/14 added
-->
<template>
    <div class="v-home">
      <p1-banner></p1-banner>
      <p2-projects></p2-projects>
      <div class="p-3-4">
        <p3-standard></p3-standard>
        <p4-honor id="id_honor"></p4-honor>
      </div>
      <p5-technology id="id_technology"></p5-technology>
      <p6-report></p6-report>
      <homebak></homebak>
    </div>
</template>

<script>
  import P1Banner from "./p1-banner";
  import P2Projects from "./p2-projects";
  import P3Standard from "./p3-standard";
  import P4Honor from "./p4-honor";
  import P5Technology from "./p5-technology";
  import P6Report from "./p6-report";
  import homebak from '../home_bak'
  export default {
    components: {P6Report, P5Technology, P4Honor, P3Standard, P2Projects, P1Banner,homebak},
    data() {
      return {

      }
    },
    mounted() {
      let to = this.$route.query.to;
      if (to){
        this.$nextTick(()=>{
          let top = $(`#${to}`).offset().top;
          top -= $('.navbar').height();
          //$(`html`).scrollTop(top);
          $('html,body').animate({scrollTop: top}, 500);
        })
      }
    },
    computed: {
      isEng: function () {
        return this.$i18n.locale == 'en-US';
      }
    },
    methods: {}
  }
</script>

<!-- banner 动画 -->
<style>

</style>
<style lang="scss">
  .en .v-home{
    p {
      font-size: 1.5vw;
      line-height: 2.5vw;
    }
  }
  .v-home{
    text-align: left;
    font-size: 12px;
    color: #000000;
    background-color: #f8f9fb;

    p {
      font-size: 2vw;
      font-weight: normal;
      font-stretch: normal;
      line-height: 3vw;
      letter-spacing: 0;
      color: #000000;
      text-align: justify;
    }

    img {
      width: 100%;
      height: 100%;
      border: none;
    }
    .p-3-4{
      background: url('../../assets/images/home/p3-4-bg.png') right top no-repeat;
      background-size: auto 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue